import { ReviewClientModel } from "./document-review.models";

export interface DocumentRequirementModel {
	documentRequirementId: number;
	customerId: number;
	createdDate?: Date;
	modifiedDate?: Date;
	createdBy: number;
	modifiedBy: number;
	customerName: string;
	name: string;
	description: string;
	vesselTypeGroupId?: number;
	visibilityAuthorized: boolean;
	isDeleted: boolean;
	documentRequirementDocuments: DocumentRequirementDocumentModel[];
	documentRequirementForms: DocumentRequirementFormModel[];
}

export interface DocumentRequirementDocumentModel {
	documentRequirementDocumentId: number;
	documentTypeId: number;
	documentValidityInDays: number;
	description: string;
}

export interface DocumentRequirementFormModel {
	documentRequirementFormId: number;
	formTypeId: number;
	documentValidityInDays: number;
	description: string;
}

export class GetDocumentRequirementResponse {
	documentRequirementSubscriptionId: number;
	documentRequirementId: number;
	name: string;
	customerName: string;
	description: string;
	noDocuments: number;
	noForms: number;
}

export class GetSubscribedDocumentRequirementResponse extends GetDocumentRequirementResponse {
	noSubscribedVessels: number;
	groupTypeId: number;
}

export class BaseGiveAccessRequest {
	grant : GrantTypeEnum;
	itemName :string;
	vesselName :string;
	vesselImo :string;
}

export class GiveFormAccessRequest extends BaseGiveAccessRequest {
	formAccessRequestId : number
}

export class GiveDocumentAccessRequest extends BaseGiveAccessRequest {
	documentAccessRequestId : number
}

export class GetAccessRequest {	
	userId?: number;
	message?: string;
	itemName?: string;
	vesselName?: string;
	vesselImo?: string;
}

export class GetDocumentAccessRequest extends GetAccessRequest{
	vesselDocumentId: number;
}

export class GetFormAccessRequest extends GetAccessRequest {
	vesselFormId: number;
}

export interface GetDocumentsAndFormsResponse {
    documents: RequirementModel[];
    forms: RequirementModel[];
}    

export interface RequirementModel
{
    requirementId: number;
    requirementName: string;
    requirementCustomerId: number;
    requirementCustomerName: string;
    subscribedCustomerId: number;
    description: string;
    uploadedByCustomer?: string;
    uploadedByCustomerId?: number;
    uploadedByUser?: string;
    uploadedByUserId?: number;
    uploadedDate?: Date;
    defaultAccessTypeId?: number;
    defaultAccessTypeName?: string;
    accessTypes?: AccessTypeModel[];
    hasAccess?: boolean;
    documentValidityInDays: number;
    hasPendingAccessRequest?: boolean;
	pendingAccessRequest?: AccessRequestModel;
	accessRequestCount?: number;
    entityType: DocumentManagementEntityTypeEnum;
    meta: FormMetaModel | DocumentMetaModel;
	actionLoading: boolean;
	review?: ReviewClientModel;

	//used when getting unique requirements
	requestingParties?: number[];
}

export interface DocumentMetaModel
{
    entityAttachmentIds?: number[];
    issueDate?: Date;
	expiryDate?: Date;
    documentTypeId: number;
    vesselDocumentId: number;
}    

export interface FormMetaModel {
    onboardingRequestId?: number;
    expiryDate?: Date;
    formTypeId: number;
    formStatus?: string;
    formStatusDate?: Date;
	formSubsmissionUrl: string;
	vesselFormId?: number;
}

export interface AccessTypeModel {
	accessTypeId: number
	customerId: number
}

export interface AccessRequestModel {
	accessRequestId: number;
	itemId: number;
	customerId?: number;
	customerName?: string;
	userId?: number;
	userName?: string;
	requestedDate?: Date;
	requestComments?: string;
	grantTypeId?: number;
}

export enum DocumentManagementEntityTypeEnum {
    DocumentRequirementSubscriptionVessel = 56,
    VesselDocument = 57,
    VesselForm = 58
}

export interface SaveDocumentVesselSubscriptionRequest {
	documentRequirementId: number;
	vesselSubscriptions: VesselSubscriptioModel[];
}

export interface VesselSubscriptioModel {
	vesselId:number;
	name:string;
	imo:string;
}

export interface GetDocumentRequirementVesselsResponse
{
	vesselId: number[];
}

export interface GetVesselDocumentRequirementsCount extends BaseResponse
{
	vesselDocumentRequirementsCounts: VesselDocumentRequirementsCount[];
}

export interface VesselDocumentRequirementsCount
{
	id: number;
	documentRequirementName: string;
	availableDocumentsCount: number;
	requiredDocumentsCount: number;
}

export interface SaveVesselFormRequest 
{
	vesselId: number;
	formTypeId: number;
	onboardingRequestId?: number;
	defaultAccessTypeId?: number;
	expiryDate?: Date;
}

export interface SubscriptionAccessModel {
	documentRequirementId: number;
	accessTypeId: number;
}

export enum GrantTypeEnum
{
	Requested = 1,
	Approve = 2,
	Reject = 3
}

export enum AccessTypeEnum
{
	AccessOnDemand = 1,
	DenyAccess = 2,
	AccessAllowed = 3
}

export interface GetCustomerNamesForDocumentsAccessRequest
{
	documentTypeId: number;
	vesselId: number;
}

export interface GetCustomerNamesAccessResponse
{
	customerName: string;
	documentRequirementName: string;
	documentRequirementSubscriptionVesselId: string;
}

export interface SaveDocumentAccessRequest extends BaseSaveAccessRequest
{
	vesselDocumentId: number;
}

export interface BaseSaveAccessRequest
{
	defaultAccessTypeId: number;

	access?: SubscriptionAccessModel[];
}

export interface SubscriptionAccessModel
{
	documentRequirementId: number;
	accessTypeId: number;
}

export interface GetAccessResponse
{
	subscriptionAccesses: SubscriptionAccessModel[];
    accessRequests: AccessRequestModel[];
}

export interface UploadDocumentRequest 
{
	access: SubscriptionAccessModel[];
	vesselId: number;
	documentTypeId: number;
	name: string;
	visibilityAuthorized: boolean;
	accurateInfoAcknoledgement: boolean;
	defaultAccessTypeId: number;
	issueDate: Date;
	expiryDate: Date;
	files: File[];
	expiredDocumentId: number;
}

export interface InspectionAccessModel {
	rightshipInspectionId: number;
	emails: string[];
}

export interface BaseResponse
{
	isSuccess: boolean;
	message: string;
	auditDetails?: string;
}

export interface GetInspectionAccessResponse extends  BaseResponse
{
	access: InspectionAccessModel
}

export interface GiveInspectionAccessResponse extends  BaseResponse
{
	
}

export interface RemoveInspectionAccessResponse extends  BaseResponse
{
	
}

export interface ListInspectionAccessResponse extends  BaseResponse
{
	accesses: InspectionAccessModel[]
}